export const DEFAULT_STORAGE_SIZE = 200;
